import React, { useState, useEffect } from "react";

const Header = (props) => {
  const [message, Message] = useState('')

  useEffect(()=>{
    Message("Salaam !")
  },[])

  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
              <div className="intro-text">
                <h1>
                  {props.data ? props.data.title : "Loading"}
                </h1>
                <p>
                  {props.data ? props.data.introduction : "Loading"}
                </p>

                <h4>{props.data ? props.data.paragraph : "Loading"}</h4>
                <a style={{marginTop:'3rem'}}
                  href="#services"
                  className="btn btn-custom btn-lg"
                >
                  Learn More
                </a>{" "}
              </div>
            </div>
        </div>
      </div>
 
    </header>
  );
};


export {Header};